import React, { useMemo, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

// --- Icono para Tareas Pendientes ---
const IconTaskPending = () => <svg className="w-4 h-4 text-yellow-500" fill="currentColor" viewBox="0 0 20 20"><path d="M10 2a6 6 0 00-6 6v3.586l-1.707 1.707A1 1 0 003 15v1a1 1 0 001 1h12a1 1 0 001-1v-1a1 1 0 00-.293-.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"></path></svg>;

const LeadCard = ({ lead, isAdmin, hasPendingTasks, provided, snapshot }) => {
    const priorityClasses = {
        high: 'border-red-500',
        medium: 'border-yellow-400',
        low: 'border-gray-300',
    };

    return (
        <div 
            ref={provided.innerRef} 
            {...provided.draggableProps} 
            {...provided.dragHandleProps} 
            className={`bg-white rounded-md p-3 shadow-sm border-l-4 ${priorityClasses[lead.interest] || 'border-transparent'} cursor-pointer hover:shadow-md transition-shadow duration-200 ${snapshot.isDragging ? 'shadow-lg ring-2 ring-blue-500' : ''}`}
        >
            <p className="font-bold text-gray-800 text-sm">{lead.contactName}</p>
            <p className="text-xs text-gray-600">{lead.company}</p>
            
            <div className="flex items-center justify-between mt-3 pt-2 border-t border-gray-100">
                <div className="flex items-center gap-2">
                    {/* --- NUEVO: Indicador de Tarea Pendiente Activado --- */}
                    {hasPendingTasks && <IconTaskPending />}
                </div>
                 {isAdmin && <p className="text-xs text-purple-600">{lead.sellerName}</p>}
            </div>
        </div>
    );
};


const KanbanView = ({ columns, onDragEnd, onSelectLead, isAdmin, pendingTasks }) => {
    // AF&B F1 (punto 5) — En movil NO se apilan las 5 columnas (eran ~300vh de scroll, con
    // las vacias ocupando lo mismo que las llenas). Se muestra UNA sola y se cambia con el
    // selector de arriba. Las 5 se siguen renderizando (ocultas con CSS) para que
    // react-beautiful-dnd conserve sus droppables y `md`+ no cambie en nada.
    //
    // Arrastrar entre columnas apiladas con el pulgar no es viable: el camino de mover un
    // lead en movil es abrir la tarjeta -> "Mover Lead" en LeadDetailModal.
    const [mobileColumnId, setMobileColumnId] = useState('new');

    const pendingTasksByLead = useMemo(() => {
        if (!pendingTasks) return {};
        return pendingTasks.reduce((acc, task) => {
            acc[task.leadId] = true;
            return acc;
        }, {});
    }, [pendingTasks]);

    if (!columns) return <div className="text-center py-10">Construyendo tablero...</div>;

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            {/* Selector de estado — solo movil. Scroll horizontal para que quepan los 5. */}
            <div className="md:hidden -mx-1 mb-4 flex gap-2 overflow-x-auto pb-1">
                {Object.values(columns).map(column => (
                    <button
                        key={column.id}
                        type="button"
                        onClick={() => setMobileColumnId(column.id)}
                        className={`flex-shrink-0 px-3 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-colors ${
                            column.id === mobileColumnId ? 'bg-blue-600 text-white shadow' : 'bg-gray-200 text-gray-700'
                        }`}
                    >
                        {column.title} ({column.leads.length})
                    </button>
                ))}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5">
                {Object.values(columns).map(column => (
                    <Droppable key={column.id} droppableId={column.id}>
                        {(provided) => (
                            <div ref={provided.innerRef} {...provided.droppableProps} className={`${column.id === mobileColumnId ? 'block' : 'hidden'} md:block bg-gray-100 rounded-lg p-3`}>
                                <h3 className="font-bold text-gray-700 px-2 pb-2 mb-2 border-b-2 border-gray-200">{column.title} ({column.leads.length})</h3>
                                <div className="min-h-[40vh] md:min-h-[60vh] space-y-3">
                                    {column.leads.map((lead, index) => (
                                        <Draggable key={lead.id} draggableId={lead.id} index={index}>
                                            {(provided, snapshot) => (
                                                <div onClick={() => onSelectLead(lead)}>
                                                    <LeadCard 
                                                        lead={lead} 
                                                        isAdmin={isAdmin} 
                                                        hasPendingTasks={pendingTasksByLead[lead.id] || false}
                                                        provided={provided} 
                                                        snapshot={snapshot} 
                                                    />
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            </div>
                        )}
                    </Droppable>
                ))}
            </div>
        </DragDropContext>
    );
};

export default KanbanView;

